import styled from '@emotion/styled'
import { ParallaxImage } from 'components/Parallax'
import { BREAKPOINTS } from 'utils/styled'
import { Block } from 'components/Block'

export const SPartnerHeroBlock = styled(Block)`
  padding: 4rem 0 0 0;
  overflow: hidden;

  @media ${BREAKPOINTS.MD.max} {
    padding: 2rem 0 0 0;
  }
`

export const SPartnerHeroWrapper = styled.div`
  margin: 0 var(--p-content);
  position: relative;
`

export const SPartnerHeroLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: calc(50% - 5.625rem);

  @media ${BREAKPOINTS.MD.max} {
    width: 100%;
  }
`

export const SPartnerHeroLeftContent = styled.div`
  position: relative;
  padding: 37px 0 42px;
  margin-top: 1rem;
  margin-bottom: 7.5rem;

  &:before {
    content: '';
    border: 2px solid var(--c-blue100);
    position: absolute;
    z-index: -1;
    top: 0;
    left: var(--p-button);
    right: -19px;
    bottom: 0;
  }

  @media ${BREAKPOINTS.MD.max} {
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 0;

    &:before {
      top: -5rem;
      bottom: 40%;
    }
  }
`

export const SPartnerHeroImageDesktop = styled(ParallaxImage)`
  object-fit: cover;
  position: absolute;
  right: 0;
  top: 0;
  width: 50%;
  z-index: -1;
  height: 100%;
  object-position: center 15%;
  @media ${BREAKPOINTS.MD.max} {
    display: none;
  }
`

export const SPartnerHeroImageMobile = styled(ParallaxImage)`
  width: 80%;
  margin: 1rem auto;
  max-height: 30vh;
  object-fit: cover;
  object-position: center 16%;
  display: none;

  @media ${BREAKPOINTS.MD.max} {
    display: block;
  }
`
